<phx-dialog
  [phxPlacement]="phxPlacement"
  [phxFullHeight]="phxFullHeight"
  [phxFullWidth]="true"
  [phxOpen]="phxOpen"
  (phxOpenChange)="onOpenChange($event)"
  (phxBackdropClicked)="onBackdropClicked()"
>
  <div class="phx-mobile-select-content" [ngClass]="cssClassMap">
    <div class="phx-mobile-select-header">
      <div class="phx-mobile-select-header-actions">
        <button phx-icon-button phxIconButtonSize="extra-large" (click)="onBackClick()" [phxIcon]="isNestedOptions ? ArrowLeftIcon : CrossIcon"></button>
      </div>
      <div class="phx-mobile-select-header-title-wrap">
        <div class="phx-mobile-select-header-subtitle">{{ headerSubTitle }}</div>
        <div class="phx-mobile-select-header-title">{{ headerTitle }}</div>
      </div>
    </div>
    <phx-search-input
      *ngIf="phxAllowSearch"
      [phxPlaceholder]="phxSearchPlaceholder"
      [ngModel]="searchValue"
      (input)="searchChange($event)"
      (phxOnClearClick)="optionList?.onClearSearch()"
    ></phx-search-input>
    <phx-selection-list
      [phxVirtualScrollEnabled]="phxVirtualScrollEnabled"
      [phxTruncateSubText]="phxTruncateSubText"
      [phxOptions]="phxOptions"
      [phxDataSource]="phxDataSource"
      [phxSearchPlaceholder]="phxSearchPlaceholder"
      [phxShowSearch]="false"
      [phxFocusSearchOnOpen]="phxFocusSearchOnOpen"
      [phxLoading]="phxLoading"
      [phxMultiple]="phxMultiple"
      [phxResultNotFound]="phxResultNotFound"
      [phxShowRadio]="phxShowRadio"
      [phxShowSubText]="phxShowSubText"
      [phxFilterPredicate]="phxFilterPredicate"
      [phxEmitOnlyIndependentSelections]="phxEmitOnlyIndependentSelections"
      [phxSearchDebounceTime]="phxSearchDebounceTime"
      [phxSelectionChangeDebounceTime]="phxSelectionChangeDebounceTime"
      [phxOptimisticSelection]="phxOptimisticSelection"
      [phxListHeight]="height"
      [phxShowHeader]="false"
      [phxAllowClear]="false"
      [phxServerSearch]="phxServerSearch"
      [phxPreventSelection]="phxPreventSelection"
      [phxHighlightSubtext]="phxHighlightSubtext"
      [phxSearchText]="phxSearchText"
      [ngModel]="selectedValue"
      (ngModelChange)="onValueChange($event)"
      (phxClear)="onClear()"
      (phxSelectionChange)="phxSelectionChange.emit($event)"
      (phxSearchChange)="phxSearchChange.emit($event)"
      (phxScrollEnd)="phxScrollEnd.emit($event)"
      (phxFocus)="phxFocus.emit($event)"
      (phxBlur)="phxBlur.emit($event)"
    ></phx-selection-list>
    <div *ngIf="phxFooterRightTemplate || showFooter && phxAllowClear" class="phx-mobile-select-footer">
      <div *ngIf="showFooter && phxAllowClear" class="phx-mobile-select-footer-content">
        <ng-container *ngIf="phxMultiple">
          <span class="phx-mobile-select-footer-counter">{{ selectedOptionCount }} {{ "selected" | phxTranslate }} </span>
          <span class="phx-mobile-select-footer-bullet"></span>
        </ng-container>
        <a selectFocusTrapItem="clear" class="phx-mobile-select-footer-clear" (click)="onClearClick()">
          {{ "Clear" | phxTranslate }}
        </a>
      </div>
      <div *ngIf="phxFooterRightTemplate" class="phx-mobile-select-footer-right">
        <ng-container *ngTemplateOutlet="phxFooterRightTemplate"></ng-container>
      </div>
    </div>
  </div>
</phx-dialog>
